import { useEventGroup } from "Hooks/Endpoints";
import React from "react";
import { Header, Segment, Table } from "semantic-ui-react";

const EventMetaView = () => {
  const { event } = useEventGroup();
  const getMeta = () => {
    const arr = [];
    for (var key in event.meta) {
      arr.push({ key, value: event.meta[key] });
    }
    return arr;
  };
  return (
    <Segment color='green'>
      <Header as='h4'>Tags</Header>
      <Table stackable celled size='small'>
        {/* <Table.Header>
          <Table.Row>
            <Table.Cell>Tag</Table.Cell>
            <Table.Cell>Value</Table.Cell>
          </Table.Row>
        </Table.Header> */}
        <Table.Body>
          {getMeta().map((obj: any) => (
            <Table.Row key={`cdr-${obj.key}`}>
              <Table.Cell>{obj.key}</Table.Cell>
              <Table.Cell>{obj.value}</Table.Cell>
            </Table.Row>
          ))}
          {getMeta().length === 0 && (
            <Segment placeholder>
              <Header as='h4'>No Tags</Header>
            </Segment>
          )}
        </Table.Body>
      </Table>
    </Segment>
  );
};

export default EventMetaView;
